
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {VekaletEntity} from "@/entity/VekaletEntity";
import {MuvekkilEntity} from "@/entity/MuvekkilEntity";

@Component({
  components: {}
})

export default class TakipAlacakliPicker extends Vue {

  @Prop({required: true}) takipId!: number;
  @Prop({default: false}) isVisible!: boolean;

  private vekaletler: Array<VekaletEntity> = []
  private muvekkiller: Array<MuvekkilEntity> = []
  private selectedMuvekkiller: Array<MuvekkilEntity> = [];
  private searchText: string = "";
  private activeStep: number = 1;
  disabled: boolean = false;

  muvekkilHeaders = [
    {text: "Adı", align: "start", sortable: false, value: "ad"},
    {text: "Vergi / TC Kimlik No", value: "no"},
  ];

  vekaletHeaders = [
    {text: "Vekalet No", align: "start", value: "vekalet_no"},
    {text: "Müvekkiller", sortable: false, value: "muvekkiller"},
    {text: "Noter", value: "isim"},
    {text: "Vekaletname Tarihi", value: "vekalet_tarihi"},
    {text: "Ekle", value: "actions", sortable: false}
  ];

  mounted() {
    this.load();
  }

  @Watch('isVisible')
  onVisibilityChange(newVal: boolean, oldVal: boolean) {
    if (newVal && !oldVal) {
      this.load();
    }
  }

  private load() {
    let action = "/api/v1/vekalet-list"
    if (this.searchText != "") {
      let no = parseInt(this.searchText);
      if (isNaN(no) || no > 999999999) {
        action = "/api/v1/vekalet/filter?keyword=" + this.searchText;
      } else {
        action = "/api/v1/vekalet/filter?no=" + this.searchText;
      }
    }

    this.$http.get(action)
        .then(response => {
          this.vekaletler = response.data;
        });

  }

  private selectVekalet(vekalet: VekaletEntity) {
    if (vekalet.muvekkiller.length == 1) {
      this.insertMuvekkiller(vekalet.muvekkiller);
    } else if (vekalet.muvekkiller.length > 1) {
      this.activeStep = 2;
      this.muvekkiller = vekalet.muvekkiller;
    }
  }

  private insertMuvekkiller(muvekkiller: Array<MuvekkilEntity>) {
    this.disabled=true;
    if (muvekkiller.length == 0) {
      this.close();
      this.disabled=false;
    }
    let data = {
      muvekkiller: muvekkiller.map(muv => muv.id)
    };
    this.$http.post("/api/v1/takip/" + this.takipId + "/alacakli", data).then(() => {
      this.$emit('load');
      this.$emit('onSuccess');
      this.close();
    }).finally(() => (this.disabled = false));
  }

  close() {
    this.muvekkiller = [];
    this.activeStep = 1;
    this.searchText = "";
    this.$emit('close');
  }
}
